<template>
  <div class="edit-part-design">
    <!-- タブ -->
    <select-tab
      :currentTab="current.tab"
      :partsContainerType="partsContainer.type"
      :displayName="partsContainer.display_name"
      @selectTab="selectTab($event)"
    />
    <!-- カラム or 行選択 -->
    <select-parts-table
      v-if="isShowMultiParts"
      :layoutType="partsContainer.layout_type"
      :tableCount="tableCount"
      :currentTableId="current.tableId"
      :partsContainerType="partsContainer.type"
      :spacerPartsExists="spacerPartsExists"
      @selectPartsTable="selectPartsTable($event)"
    />
    <!-- セクション移動時に再描画させるため、keyとして持たせておく -->
    <div
      class="parts-editor"
      :class="{tab: partsContainer.parts && (isMultiRowPart || isMultiColumnPart)}"
      :key="sectionId"
    >
      <!-- テキストパーツ -->
      <text-edit
        v-if="showTextEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
        :columnCount="partsContainer.column_count"
        :flgSide="partsContainer.flg_side"
        :extTypeName="extTypeName"
        @adjustCurrentTableId="adjustCurrentTableId"
      />
      <!-- テキストボックスパーツ -->
      <boxed-text-edit
        v-if="showBoxedTextEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
        :columnCount="partsContainer.column_count"
        :flgSide="partsContainer.flg_side"
        :extTypeName="extTypeName"
        @adjustCurrentTableId="adjustCurrentTableId"
      />
      <!-- 罫線パーツ -->
      <divider-edit
        v-if="showDividerEdit"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
      />
      <!-- 画像、ロゴパーツ -->
      <image-edit
        v-if="showImageEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
      />
      <!-- 画像グループパーツ -->
      <image-group-edit
        v-if="showImageGroupEdit"
        :current="current"
        :styles="partsContainer.styles"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
        :firstPartStyles="partsContainer.parts[0].styles"
        :flgSide="partsContainer.flg_side"
        :flgImageContentMobileFullWidth="partsContainer.flg_image_content_mobile_full_width"
      />
      <!-- 画像カードパーツ -->
      <image-card-edit
        v-if="showImageCardEdit"
        :current="current"
        :styles="partsContainer.styles"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :isMultiPart="{ row: isMultiRowPart, column: isMultiColumnPart }"
        :extTypeName="extTypeName"
      />
      <!-- 画像テキストパーツ -->
      <image-text-edit
        v-if="showImageTextEdit"
        :current="current"
        :styles="partsContainer.styles"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :isMultiPart="{ row: isMultiRowPart, column: isMultiColumnPart }"
        :flgSide="partsContainer.flg_side"
        :flgImageContentMobileFullWidth="partsContainer.flg_image_content_mobile_full_width"
        :extTypeName="extTypeName"
        @adjustCurrentTableId="adjustCurrentTableId"
      />
      <!-- フォローボタンパーツ -->
      <follow-button-edit
        v-if="showFollowButtonEdit"
        :current="current"
        :partsContainer="partsContainer"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :styles="partsContainer.styles"
        @adjustCurrentTableId="adjustCurrentTableId"
      />
      <!-- ボタンパーツ -->
      <button-edit
        v-if="showButtonEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
        @input="updatePartBody"
      />
      <!-- フッターパーツ -->
      <footer-edit
        v-if="showFooterEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partsContainerStyles="partsContainer.styles"
        :columnCount="partsContainer.column_count"
        :flgSide="partsContainer.flg_side"
        :extTypeName="extTypeName"
        @adjustCurrentTableId="adjustCurrentTableId"
      />
      <!-- コードパーツ -->
      <code-edit
        v-if="showCodeEdit"
        :current="current"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :partId="partsContainer.parts[0].id"
        @input="updatePartBody"
      />
      <!-- シェアボタン -->
      <share-edit
        v-if="showShareEdit"
        :current="current"
        :partsContainer="partsContainer"
        :parts="partsContainer.parts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :partsContainerType="partsContainer.type"
        :styles="partsContainer.styles"
      />
    </div>
    <div id="parts-footer">
      <MultiPartsCopyButton
        v-if="isShowMultiParts"
        :sectionId="partsContainer.section_id"
        :partsContainerId="partsContainer.id"
        :tableId="current.tableId"
        :tab="current.tab"
      />
      <close-button
        @close="closeEditor"
        class="close-btn"
      />
    </div>
  </div>
</template>

<script>
import SelectTab from '@/components/Content/Palette/EditPartDesign/Layouts/SelectTab'
import SelectPartsTable from '@/components/Content/Palette/EditPartDesign/Layouts/SelectPartsTable'
import TextEdit from '@/components/Content/Palette/EditPartDesign/Editor/Text'
import BoxedTextEdit from '@/components/Content/Palette/EditPartDesign/Editor/BoxedText'
import DividerEdit from '@/components/Content/Palette/EditPartDesign/Editor/Divider'
import ImageEdit from '@/components/Content/Palette/EditPartDesign/Editor/Image'
import ImageGroupEdit from '@/components/Content/Palette/EditPartDesign/Editor/ImageGroup'
import ImageCardEdit from '@/components/Content/Palette/EditPartDesign/Editor/ImageCard'
import ImageTextEdit from '@/components/Content/Palette/EditPartDesign/Editor/ImageText'
import FollowButtonEdit from '@/components/Content/Palette/EditPartDesign/Editor/FollowButton'
import ButtonEdit from '@/components/Content/Palette/EditPartDesign/Editor/Button'
import FooterEdit from '@/components/Content/Palette/EditPartDesign/Editor/Footer'
import CodeEdit from '@/components/Content/Palette/EditPartDesign/Editor/Code'
import ShareEdit from '@/components/Content/Palette/EditPartDesign/Editor/Share'
import MultiPartsCopyButton from '@/components/Content/Palette/EditPartDesign/Layouts/MultiPartsCopyButton'
import CloseButton from '@/components/Content/Palette/EditPartDesign/Layouts/CloseButton'
import constants from '@/constants'

export default {
  props: [
    'sectionId',
    'partsContainerId',
  ],
  components: {
    SelectTab,
    SelectPartsTable,
    TextEdit,
    BoxedTextEdit,
    DividerEdit,
    ImageEdit,
    ImageGroupEdit,
    ImageCardEdit,
    ImageTextEdit,
    FollowButtonEdit,
    ButtonEdit,
    FooterEdit,
    CodeEdit,
    ShareEdit,
    CloseButton,
    MultiPartsCopyButton,
  },
  data () {
    return {
      current: {
        tab: 'Content',
        column: null,
        tableId: null,
      },
      partsContainer: null,
      extTypeName: '',
    }
  },
  computed: {
    showTextEdit () {
      return this.partsContainer.type === 'Text' && this.extTypeName
    },
    showBoxedTextEdit () {
      return this.partsContainer.type === 'BoxedText' && this.extTypeName
    },
    showDividerEdit () {
      return this.partsContainer.type === 'Divider'
    },
    showImageEdit () {
      // ロゴも画像パーツとして扱う
      return this.partsContainer.type === 'Image' || this.partsContainer.type === 'Logo'
    },
    showImageGroupEdit () {
      return this.partsContainer.type === 'ImageGroup'
    },
    showImageCardEdit () {
      return this.partsContainer.type === 'ImageCard' && this.extTypeName
    },
    showImageTextEdit () {
      return this.partsContainer.type === 'ImageText' && this.extTypeName
    },
    showFollowButtonEdit () {
      return this.partsContainer.type === 'FollowButton'
    },
    showButtonEdit () {
      return this.partsContainer.type === 'Button'
    },
    showFooterEdit () {
      return this.partsContainer.type === 'Footer' && this.extTypeName
    },
    showCodeEdit () {
      return this.partsContainer.type === 'Code'
    },
    showShareEdit () {
      return this.partsContainer.type === 'Share'
    },
    // マルチrowパーツの判定
    isMultiRowPart () {
      // [ ImageGroup ] は、無条件でマルチrowパーツにはならない
      if (this.partsContainer.type === 'ImageGroup') return false

      // 縦レイアウト かつ、カラム数が1より大きい
      return this.partsContainer.layout_type === 'vertical' && this.partsContainer.column_count > 1
    },
    // マルチcolumnパーツの判定
    isMultiColumnPart () {
      // [ ImageGroup ] は、無条件でマルチcolumnパーツにはならない
      if (this.partsContainer.type === 'ImageGroup') return false

      let isMultiColumnPart = false
      if (this.partsContainer.layout_type === 'horizontal' && this.partsContainer.column_count > 1) {
        // 横レイアウトでカラム数が1より大きい
        if (this.partsContainer.type === 'Text' || this.partsContainer.type === 'BoxedText' || this.partsContainer.type === 'Footer') {
          // (1) 種類が [ Text ] [ BoxedText ] [ Footer ]
          isMultiColumnPart = true
        } else if (this.partsContainer.table_count !== this.partsContainer.parts.length) {
          // (2) パーツテーブル数とパーツ数が異なる
          isMultiColumnPart = true
        }
      }
      return isMultiColumnPart
    },
    // テーブル数
    tableCount () {
      if (!this.partsContainer) return null
      if (this.partsContainer.type === 'Text' || this.partsContainer.type === 'BoxedText' || this.partsContainer.type === 'Footer') {
        // テキスト、テキストボックス、フッター：スペーサー以外のパーツ数を返す
        return this.partsContainer.parts.filter(part => part.type !== 'Spacer').length
      } else if (this.partsContainer.type === 'ImageText') {
        // 画像テキスト：画像数を返す
        const imageParts = this.partsContainer.parts.filter(part => part.type === 'Image')
        return imageParts.length
      } else {
        // その他：テーブル数を返す
        return this.partsContainer.table_count
      }
    },
    // パーツ間にスペーサーが存在するかどうか
    spacerPartsExists () {
      if (!this.partsContainer) return null
      const spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer' && part.order_id === 1)
      return spacerParts.length > 0
    },
    isShowMultiParts () {
      return this.partsContainer.parts && (this.isMultiRowPart || this.isMultiColumnPart) && ['Content', 'Style'].includes(this.current.tab)
    }
  },
  methods: {
    initComponent () {
      this.current.tableId = 1

      // コードパーツを選択したとき、コードに独自属性が存在する場合は、タブを独自属性編集用のものに変更する
      if (this.partsContainer.type === 'Code' && this.countBodyMPHEAttrs(this.partsContainer.parts[0].body) > 0) {
        this.selectTab('Tag')
      } else {
        this.current.tab = 'Content'
      }

      // カラーピッカーを閉じる
      this.$store.commit('updateStatusColorPicker', { prop: 'pane', value: null })
      this.$store.commit('updateStatusColorPicker', { prop: 'prop', value: null })
    },
    selectTab (tab) {
      if (this.partsContainer.type === 'Code') {
        if (this.partsContainer.parts[0].body) {
          const regex = /<img[^>]*data-image-key="([^\s^>]+)"[^>]*>/g
          const matches = this.partsContainer.parts[0].body.matchAll(regex)
          const imageKeys = []
          for (const match of matches) {
            if (match.length > 1) {
              if (imageKeys.includes(match[1])) {
                this.current.tab = 'Content'
                return this.$store.commit('showErrorMessagePopup', [
                  `data-image-key="${match[1]}"が重複しています`,
                  `コードから削除して設定しなおしてください`
                ])
              }
              imageKeys.push(match[1])
            }
          }
          if (this.countBodyMPHEAttrs(this.partsContainer.parts[0].body) > constants.maxCodePartMPHEAttrCount) {
            this.current.tab = 'Content'
            return this.$store.commit('showErrorMessagePopup', [
              '1つのコードパーツに設定可能な独自属性数を超えています',
              `（上限：${constants.maxCodePartMPHEAttrCount}個）`
            ])
          }
        }
      }
      this.current.tab = tab
    },
    getExtTypeName () {
      this.$http({
        url: `/site`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.extTypeName = json.data.extTypeName
        }
      })
    },
    // 独自属性数をカウント
    countBodyMPHEAttrs (body) {
      let matchesCount = 0
      const regexEdit = /<[\s\S]+?[^>]data-mphe-edit="([^\s^>]+)"[^>]*>/g
      const regexLink = /<[\s\S]+?[^>]data-mphe-link="([^\s^>]+)"[^>]*>/g
      const regexImage = /<[\s\S]+?[^>]data-mphe-image="([^\s^>]+)"[^>]*>/g
      matchesCount = body.match(regexEdit) ? this.partsContainer.parts[0].body.match(regexEdit).length : 0
      matchesCount += body.match(regexLink) ? this.partsContainer.parts[0].body.match(regexLink).length : 0
      matchesCount += body.match(regexImage) ? this.partsContainer.parts[0].body.match(regexImage).length : 0
      return matchesCount
    },
    selectPartsTable (column) {
      this.current.tableId = column
    },
    // 現在のcurrent.tableIdを調整
    async adjustCurrentTableId (type) {
      await this.$nextTick()
      switch (type) {
        // カラムが追加されたときは何もしない
        case 'DECREASE_COLUMN': // カラムが減った場合
          // 選択中のテーブルが削除された場合は、末尾のテーブルを選択させる
          if (this.current.tableId > this.partsContainer.table_count) {
            this.selectPartsTable(this.partsContainer.table_count)
          }
          // マルチカラムではなくなった場合、current.tableIdを戻す
          if (this.partsContainer.table_count === 1) {
            this.selectPartsTable(1)
          }
          break
        case 'ADD_SPACER': // 間隔を0より大きくした場合
          this.selectPartsTable(this.current.tableId * 2 - 1)
          break
        case 'DELETE_SPACER': // 間隔を0にした場合
          // 最初のテーブルを選択中以外はスペーサー分削除
          if (this.current.tableId !== 1) {
            this.selectPartsTable(this.current.tableId - Math.floor(this.current.tableId / 2))
          }
          break
      }
    },
    closeEditor () {
      this.$emit('close')
    },
    updatePartBody (event) {
      this.$store.commit('updatePartBody', event)
    },
    getPartsContainer () {
      if (!this.sectionId || !this.partsContainerId) return null
      // パレットの更新
      this.partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      this.$store.commit('updateStatusPalette', {
        partsContainerType: this.partsContainer.type,
        sectionId: this.partsContainer.section_id,
        partsContainerId: this.partsContainer.id,
      })
    }
  },
  beforeMount () {
    this.getPartsContainer()
    this.getExtTypeName()
  },
  mounted () {
    this.initComponent()
  },
  watch: {
    // 対象のパーツが変更されたら、表示を初期化する
    'partsContainer.id' () {
      this.initComponent()
    },
    'partsContainerId' () {
      this.getPartsContainer()
    },
    // 対象のセクションIDが移動したら、パーツコンテナを再取得する
    'sectionId' () {
      this.getPartsContainer()
    }
  }
}
</script>

<style lang="scss" scoped>
.parts-editor {
  height: calc(100vh - 264px);
  overflow: auto;
  &.tab {
    height: calc(100vh - 320px);
  }
}
#parts-footer {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  border-top: #dbdbdb 1px solid;
  .close-btn {
    position: absolute;
    bottom: 0;
    right: 10px;
  }
}

</style>
